import $api from "@/api/ApiInteceptor";
import { INotificationsResponse } from "@/struct/INotifications/INotification";
import { EWebMethod } from "@/struct/IRequest/IRequest";

export interface ITransactionsFilters {
  datetime_from?: string | null;
  datetime_to?: string | null;
  limit?: number | null;
  card_suffix?: string | null;
  status?: string | null;
  status_adapter?: string | null;
}

export default class ApiNotifications {
  public static async getTransactions(
    filters: ITransactionsFilters = {},
  ): Promise<INotificationsResponse | boolean> {
    try {
      const body: Record<string, unknown> = {};

      if (filters.datetime_from) {
        body.datetime_from = filters.datetime_from;
      }
      if (filters.datetime_to) {
        body.datetime_to = filters.datetime_to;
      }
      if (filters.limit) {
        body.limit = filters.limit;
      }
      if (filters.card_suffix) {
        body.card_suffix = filters.card_suffix;
      }
      if (filters.status) {
        body.status = filters.status;
      }
      if (filters.status_adapter) {
        body.status_adapter = [filters.status_adapter];
      }

      const response = await $api.call(
        EWebMethod.POST,
        "/api/v6/mobile/driver/transactions",
        body,
      );
      return response.data;
    } catch (e) {
      return false;
    }
  }

  public static async getTransactionsScroll(
    scrollId: string,
  ): Promise<INotificationsResponse | boolean> {
    try {
      const response = await $api.call(
        EWebMethod.GET,
        `/api/v6/mobile/driver/transactions/scroll?scroll_id=${scrollId}`,
      );
      return response.data;
    } catch (e) {
      return false;
    }
  }
}
